import { cloneDeep } from 'lodash'

export const insertValueInList = (originalList, a, b) => {
  if(Array.isArray(originalList)){
    const temp = cloneDeep(originalList)
    if(a > b){
      temp.splice(b, 0, originalList[a])
      temp.splice(a + 1, 1)
    }
    else if(b > a ){
      temp.splice(b + 1, 0, originalList[a])
      temp.splice(a, 1)
    }

    return temp
  }
  return originalList
}